import React, { useEffect, useState } from "react";

const formatVisitors = (visitors) => {
  if (!Number.isFinite(visitors) || visitors <= 0) {
    return null;
  }

  return `${new Intl.NumberFormat("en", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(visitors)}+`;
};

const SiteVisitorCount = () => {
  const [displayVisitors, setDisplayVisitors] = useState(null);

  useEffect(() => {
    let isActive = true;

    fetch("/.netlify/functions/get-site-visitors")
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const formatted = formatVisitors(Number(data?.visitors));
        if (isActive && formatted) {
          setDisplayVisitors(formatted);
        }
      })
      .catch(() => {
        // Silently fail: site visitor count is non-critical footer context.
      });

    return () => {
      isActive = false;
    };
  }, []);

  if (!displayVisitors) {
    return null;
  }

  return (
    <div
      className="footer-site-visitors"
      title="Total users reported by the Predinfer GA4 property since analytics tracking began."
      aria-label={`Total visitors: ${displayVisitors}. Total users reported by the Predinfer GA4 property since analytics tracking began.`}
    >
      <span className="footer-site-visitors-label">Total visitors</span>
      <span className="footer-site-visitors-value">{displayVisitors}</span>
    </div>
  );
};

export default SiteVisitorCount;
